import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import AvailableSequenceOfOperationsPage from 'containers/AvailableSequenceOfOperationsPage';
import queryClient from 'react-query-settings/queryClient';
import { Provider } from 'react-redux';
import sequenceOfOperationsPageReducer, {
  initialState,
} from 'reducers/sequenceOfOperationsPageReducer';
import { createStore } from 'redux';

import AppWrapper from 'components/apps/AppWrapper';

export default function SequenceOfOperationsApp({
  contextProps,
  wrappedProps,
}) {
  const { isReviewing, projectId } = wrappedProps;

  const store = createStore(sequenceOfOperationsPageReducer, {
    ...initialState,
    application: {
      ...initialState.application,
      isReviewing,
      projectId,
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <Provider store={store}>
          <AvailableSequenceOfOperationsPage projectId={projectId} />
        </Provider>
      </AppWrapper>
    </QueryClientProvider>
  );
}
